<div class="px-2 md:px-6 flex flex-col justify-start items-start gap-2 relative min-h-screen pb-[50px]">
	<div (click)="dialogRef.close()"
		 class="sticky w-max top-1 left-0 -ml-4 px-2 pt-2 bg-[#D4A373] rounded">
			<span class="material-symbols-outlined cursor-pointer text-white">
				close
			</span>
	</div>
	<h2 class="w-full font-semibold text-[#3c3c3c] text-lg md:text-2xl text-center">
		Pre Order
	</h2>
	<div class="w-full flex justify-center">
		<div class="fb-disclaimer-box flex items-center gap-2">
			<span class="material-symbols-outlined">error</span>
			<p>An advance payment of 50% is required at checkout</p>
		</div>
	</div>

	<div *ngIf="this.product.specialStatus" class="f-g-badge">
		{{this.product.specialStatus.name}}
	</div>
	<h1 class="fb-font-dm fb-product-header">{{this.product.name}}</h1>

	<fb-product-sku [value]="product.sku"></fb-product-sku>

	<fb-product-price class="w-full"
					  [product]="product"
					  [price]="calculatedPrice"
					  [discountedPrice]="calculatedDiscountPrice"
					  [fabricSelected]="!!selectedFabric"></fb-product-price>
	<fb-product-bulk-discount *ngIf="product.volumeDiscountProfileEnabled && product.volumeDiscountProfile"
							  [product]="product"
							  [calculatedPrice]="calculatedPrice"
							  [selectedFabric]="selectedFabric"
							  [volumeDiscountProfile]="product.volumeDiscountProfile"></fb-product-bulk-discount>
	<fb-product-custom-fabric-profile *ngIf="product.fabricProfileEnabled && product.fabricProfile"
									  [product]="product"
									  [fabricProfile]="product.fabricProfile"
									  (fabricSelected)="fabricSelected($event)"></fb-product-custom-fabric-profile>
	<div *ngIf="product.sizeProfileEnabled && product.sizeProfile"
		 class="mt-2">
		<fb-product-size-profile [product]="product"
								 [sizeProfile]="product.sizeProfile"
								 (sizeSelected)="onSizeSelected($event)"
								 (customSizeSelected)="onCustomSizeSelected($event)"></fb-product-size-profile>
	</div>
	<fb-product-finish-profile *ngIf="product.finishProfileEnabled && product.finishProfile"
							   [product]="product"
							   [finishProfile]="product.finishProfile"
							   (finishSelectionChange)="finishSelectionChange($event)"></fb-product-finish-profile>
	<fb-product-pre-order-quantity-input [product]="product"
							   [unit]="product.unit"
							   [minOrderQuantity]="minimumOrderQuantity"
							   [stockMessage]="stockMessage"
							   (quantityChange)="onQuantityChange($event)"></fb-product-pre-order-quantity-input>

	<button class="w-full fb-add-to-cart primary-button mt-2">Pre-Order Now</button>

	<div *ngIf="fromDays && toDays"
		 class="flex gap-2 items-center">
		<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clip-path="url(#clip0_2116_153)">
				<path d="M28.05 15.5719L25.2375 9.00937C25.1657 8.83992 25.0457 8.69534 24.8923 8.59365C24.7389 8.49196 24.559 8.43765 24.375 8.4375H21.5625V6.5625C21.5625 6.31386 21.4637 6.0754 21.2879 5.89959C21.1121 5.72377 20.8736 5.625 20.625 5.625H2.8125C2.56386 5.625 2.3254 5.72377 2.14959 5.89959C1.97377 6.0754 1.875 6.31386 1.875 6.5625V22.5C1.875 22.7486 1.97377 22.9871 2.14959 23.1629C2.3254 23.3387 2.56386 23.4375 2.8125 23.4375H4.81875C5.03464 24.2319 5.50594 24.9332 6.15993 25.4332C6.81393 25.9332 7.61428 26.2041 8.4375 26.2041C9.26072 26.2041 10.0611 25.9332 10.7151 25.4332C11.3691 24.9332 11.8404 24.2319 12.0562 23.4375H17.9437C18.1596 24.2319 18.6309 24.9332 19.2849 25.4332C19.9389 25.9332 20.7393 26.2041 21.5625 26.2041C22.3857 26.2041 23.1861 25.9332 23.8401 25.4332C24.4941 24.9332 24.9654 24.2319 25.1813 23.4375H27.1875C27.4361 23.4375 27.6746 23.3387 27.8504 23.1629C28.0262 22.9871 28.125 22.7486 28.125 22.5V15.9375C28.1248 15.8118 28.0993 15.6875 28.05 15.5719ZM21.5625 10.3125H23.7563L25.7625 15H21.5625V10.3125ZM8.4375 24.375C8.06666 24.375 7.70415 24.265 7.39581 24.059C7.08746 23.853 6.84714 23.5601 6.70523 23.2175C6.56331 22.8749 6.52618 22.4979 6.59853 22.1342C6.67087 21.7705 6.84945 21.4364 7.11167 21.1742C7.3739 20.912 7.70799 20.7334 8.07171 20.661C8.43542 20.5887 8.81242 20.6258 9.15503 20.7677C9.49764 20.9096 9.79048 21.15 9.99651 21.4583C10.2025 21.7666 10.3125 22.1292 10.3125 22.5C10.3125 22.9973 10.115 23.4742 9.76332 23.8258C9.41169 24.1775 8.93478 24.375 8.4375 24.375ZM17.9437 21.5625H12.0562C11.8404 20.7681 11.3691 20.0668 10.7151 19.5668C10.0611 19.0668 9.26072 18.7959 8.4375 18.7959C7.61428 18.7959 6.81393 19.0668 6.15993 19.5668C5.50594 20.0668 5.03464 20.7681 4.81875 21.5625H3.75V7.5H19.6875V19.275C19.2606 19.5228 18.8868 19.8524 18.5876 20.2449C18.2884 20.6375 18.0696 21.0852 17.9437 21.5625ZM21.5625 24.375C21.1917 24.375 20.8291 24.265 20.5208 24.059C20.2125 23.853 19.9721 23.5601 19.8302 23.2175C19.6883 22.8749 19.6512 22.4979 19.7235 22.1342C19.7959 21.7705 19.9745 21.4364 20.2367 21.1742C20.4989 20.912 20.833 20.7334 21.1967 20.661C21.5604 20.5887 21.9374 20.6258 22.28 20.7677C22.6226 20.9096 22.9155 21.15 23.1215 21.4583C23.3275 21.7666 23.4375 22.1292 23.4375 22.5C23.4375 22.9973 23.24 23.4742 22.8883 23.8258C22.5367 24.1775 22.0598 24.375 21.5625 24.375ZM26.25 21.5625H25.1813C24.9739 20.7596 24.5063 20.048 23.8515 19.5391C23.1968 19.0302 22.3918 18.7527 21.5625 18.75V16.875H26.25V21.5625Z" fill="#7D5A20"/>
			</g>
			<defs>
				<clipPath id="clip0_2116_153">
					<rect width="30" height="30" fill="white"/>
				</clipPath>
			</defs>
		</svg>
		<div class="flex flex-wrap gap-1.5 items-center">
			<div class="flex flex-wrap items-center gap-1.5">
				Pre Order, Estimated Date Of Delivery
			</div>

			<br/>
			<span class="font-bold">{{(fromDays | formatDate).split(',')[0]}} to {{toDays | formatDate}}</span>
		</div>
	</div>
</div>
